import React,{Component} from 'react';
import { firebaseAuth,ref} from '../config/constants'

import Sidebar from './inc/Sidebar';
import Header from './inc/Header';
import Title from './inc/Title';
import Footer from './inc/Footer';



class InventoryOutProduct extends Component{
    constructor(){
        super();
        this.save = this.save.bind(this)
        this.handleQuantity = this.handleQuantity.bind(this)
        this.state={
            userId : "",
            user : {},
            productName : "",
            outProduct :{}
        }
        
    }

    componentDidMount(){
        this.listener = firebaseAuth().onAuthStateChanged(user=>{
            if (user){
                var db = ref.child("users").child(user.uid);
                    db.on("value",function(data){
                      
                        this.setState({
                            userId:data.key,
                            user:data.val()
                        });

                    }.bind(this));
            }else{
                this.props.history.push("/login");
            }

        });

        var inventory = ref.child("Inventory").child("Products").child(this.props.match.params.id)
            inventory.on("value", function(snap){
                this.setState({
                    outProduct : snap.val()
                })
            }.bind(this))    
    }
    handleQuantity(e){
        if(e.target.value > this.state.outProduct.product_count){
            alert("Out of Range")
            e.target.value = this.state.outProduct.product_count
        }
    }
    save(e){
        e.preventDefault();
        var newCount = parseInt(this.state.outProduct.product_count,10) - parseInt(this.quantity.value,10)
        console.log(newCount)
        let update ={
            
            product_count : newCount
        }
        let stockOut={
            status: "Out",
            product_Id : this.state.outProduct.product_Id,
            product_count : this.quantity.value,
            product_name : this.name.value,
            date : Date(),
            product_color : this.color.value,
            remarks : this.remarks.value,
            product_length : this.length.value
        }
        ref.child("Inventory").child("Products").child(this.props.match.params.id).update(update).then(alert("Product has been deducted"))
        ref.child("StockCard").child("Products").push(stockOut)
    }
    

    
          
    render() {

        return (
            <div id="page-wrapper">
                <div id="page-container" className="sidebar-partial sidebar-visible-lg sidebar-no-animations">
                    <Sidebar  role={this.state.user.role} />
                    <div id="main-container">
                        <Header />
                        <div id="page-content">
                            <Title title=" Inventory Out Product" />
                            <div className="block">

                                <form className="form-horizontal form-bordered" ref={input => this.formSubmit = input} onSubmit={this.save}>
                                    <div className="form-group">
                                        <label className="col-md-3 control-label" htmlFor="product-id">Product Name</label>
                                        <div className="col-md-4">
                                            <input className="form-control" ref={(input) => {this.name=input}} type="text" value={this.state.outProduct.product_name} />
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label className="col-md-3 control-label" htmlFor="product-id">Product Length</label>
                                        <div className="col-md-4">
                                            <input className="form-control" ref={(input) => {this.length=input}} type="text" value={this.state.outProduct.product_length} />
                                        </div>
                                    </div>
                                    
                                    <div className="form-group">
                                        <label className="col-md-3 control-label" htmlFor="product-id">Product Color</label>
                                        <div className="col-md-4">
                                            <input className="form-control" ref={(input) => {this.color=input}} type="text" value={this.state.outProduct.product_color}/>
                                        </div>
                                    </div>
                                    
                                    <div className="form-group">
                                        <label className="col-md-3 control-label" htmlFor="product-id">Enter Quantity</label>
                                        <div className="col-md-4">
                                            <input className="form-control" ref={(input) => {this.quantity=input}} type="number" min="1" max={this.state.outProduct.product_count} onChange={this.handleQuantity}/>
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label className="col-md-3 control-label" htmlFor="product-id">Remarks</label>
                                        <div className="col-md-4">
                                            <textarea className="form-control" rows="3" ref={(input) =>{this.remarks=input}} ></textarea>
                                        </div>
                                    </div>
                                        
                                    <div className="form-group form-actions">
                                        <div className="col-md-9 col-md-offset-3">
                                            <button type="submit" className="btn btn-sm btn-primary"><i className="fa fa-floppy-o"></i> Save</button>
                                        </div>
                                    </div>
                                </form>               
                            </div>                                
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>
      
        );
    }
}

export default  InventoryOutProduct;



// WEBPACK FOOTER //
// ./src/components/InventoryOutProduct.js